
































































































    import { Component, Watch } from "../../../Infrastructure/CorBase/CoreBase";
	import GroupDetailBase from "./GroupDetailBase";
	import store from '../../../Infrastructure/CorBase/StoreBase';

	@Component
	export default class GroupDetail extends GroupDetailBase {


		created() {
			super.initializeRights('COR_Group_Create', 'COR_Group_Delete', 'COR_Group_Read', 'COR_Group_Update');
			super.setMainDescription('group.new', 'group.detail');

            this.mainDataChanged = false;
		}

		infoShortInput(value: string) {
			this.infoShortInputBase(value);
		}

		mounted() {
			super.mounted();
		};

		validate() {
			return this.validateBase();
		}

		isCorrectName(value: any) {
			this.isCorrectNameBase(value);
		}

		isCorrectDescription(value: any) {
			this.isCorrectDescriptionBase(value);
		}

		isCorrectGroup(value: any) {
			this.isCorrectGroupBase(value);
		}

		preventRefresh(event: any) {
			if (this.$store.state.askBeforeCancelEditing === true && this.formIsInEditMode && this.dataWasChanged()) {
                event.preventDefault(); event.returnValue = "";
            }

        }

		beforeMount() {
            window.addEventListener("beforeunload", this.preventRefresh);
        }

		beforeDestroy() {
            window.removeEventListener("beforeunload", this.preventRefresh);
            this.$store.commit("formIsInEditMode", false);
            this.$store.commit("mainDataChanged", false);
		}

		//@ts-ignore
        @Watch('$i18n.locale')
        changeFieldsAfterChangeLanguage(value: boolean, oldValue: boolean) {
            this.changeFieldsAfterChangeLanguageBase(value, oldValue);
        }
	}

